<template>
    <div class="editor-js">
        <div v-for="(el, key) in json.blocks" :key="key">
            <div v-if="el">
                <!-- Paragraph -->
                <div v-if="el.type == 'paragraph'" class="parrafo">
                    <p v-html="el.data.text"></p>
                </div>

                <!-- Image -->
                <div v-else-if="el.type == 'image'" class="contenedor-imagen">
                    <img :src="el.data.file.url" class="img-full" />
                    <span v-html="el.data.caption" class="pie"></span>
                </div>

                <!-- Header -->
                <div v-else-if="el.type == 'header'">
                    <component
                        :is="'h' + el.data.level"
                        :class="el.data.level === 4 ? 'destacado-noticia' : 'title--sup -green-line -black'"
                        :style="{ 'text-align': el.data.alignment || 'left' }"
                        v-html="el.data.text"
                    />
                </div>


                <!-- Embed -->
                <div v-else-if="el.type == 'embed'" :data-service="el.data.service">
                    <iframe :src="el.data.embed"></iframe>
                </div>

                <!-- File -->
                <div v-else-if="el.type == 'attaches'" class="descargable row-center">
                    <a download :href="el.data.file.url" class="enlace-cover" rel="noopener" target="_blank"></a>
                    <span class="icon"></span>
                    <p v-if="el.data.title">{{ el.data.title }}</p>
                </div>

                <!-- Prety Link -->
                <div v-else-if="el.type == 'linkTool'" class="contenedor-link row-center">
                    <div class="link row-start">
                        <a
                            :href="el.data.link"
                            class="enlace-cover"
                            rel="noopener"
                            :target="el.data.blank ? '_blank' : '_self'"
                        ></a>
                        <template v-if="el.data.meta && el.data.meta.image">
                            <img v-if="el.data.meta.image.url" :src="el.data.meta.image.url" alt="imagen">
                        </template>
                        <h2>{{ el.data.meta && el.data.meta.title ? el.data.meta.title : '' }}</h2>
                        <p>{{ el.data.meta && el.data.meta.description ? el.data.meta.description : '' }}</p>
                    </div>
                </div>

                <!-- List -->
                <ul v-else-if="(el.type == 'list' || el.type == 'nestedList') && el.data.style == 'unordered'">
                    <li v-for="(item, index) in normalizeListItems(el.data.items)" :key="index" v-html="item.content"></li>
                </ul>

                <ol v-else-if="(el.type == 'list' || el.type == 'nestedList') && el.data.style == 'ordered'">
                    <li v-for="(item, index) in normalizeListItems(el.data.items)" :key="index" v-html="item.content"></li>
                </ol>

                <!-- Boton -->


                <div v-else-if="el.type == 'button'" class="button">
                    <a target="_blank" :href="el.data.link">
                        {{ el.data.text }}
                    </a>
                </div>

                <!-- Tabla -->
                <div v-else-if="el.type == 'table'" class="table">
                    <table>
                        <tr v-for="(td, tdkey) in el.data.content" :key="tdkey">
                            <td :key="ekey" v-for="(e, ekey) in td" v-html="e"></td>
                        </tr>
                    </table>
                </div>

                <!-- Columnas -->
                <div v-else-if="el.type == 'columns'" class="grid">
                    <div
                        v-for="(column, subkey) in el.data.itemContent"
                        :key="subkey"
                        :class="['grid-12', `grid-md-${Math.floor(12 / el.data.itemContent.length)}`]"
                    >
                        <editorJs :object="column"></editorJs>
                    </div>
                </div>

                <!-- Raw -->
                <div v-else class="raw">
                    <div v-html="el.data.html"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.slider {
    .gallery-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        border: none;
        margin-bottom: 12px;

        img {
            margin-bottom: 5px;
        }
    }
}
</style>

<script>
export default {
    name: "EditorJs",
    props: {
        object: {
            required: true,
        },
    },
    computed: {
        json() {
            if (typeof this.object === "string" || this.object instanceof String) {
                return JSON.parse(this.object);
            }
            return this.object;
        },
    },
    methods: {
        normalizeListItems(items = []) {
            return items.map((item) => {
                if (typeof item === "string") return { content: item };
                return { content: item && item.content ? item.content : "" };
            });
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/editorJs.vue